export type SyndicateEntitlements = {
  cmgEntityKey: string;
  entitlements?: readonly string[] | null;
};

export const findEntitlements: (options: {
  cmgEntityKey: string | null;
  syndicatesEntitlements: readonly SyndicateEntitlements[];
}) => readonly string[] = ({ cmgEntityKey, syndicatesEntitlements }) => {
  return cmgEntityKey
    ? syndicatesEntitlements.find(
        syndicateEntitlements => syndicateEntitlements.cmgEntityKey === cmgEntityKey
      )?.entitlements ?? []
    : [];
};

type CanSyndicateManagerUpdateInstitutionalIndicationProps = {
  cmgEntityKey: string | null | undefined;
  syndicatesEntitlements: readonly SyndicateEntitlements[];
};

export const canSyndicateManagerUpdateInstitutionalIndication = ({
  cmgEntityKey,
  syndicatesEntitlements,
}: CanSyndicateManagerUpdateInstitutionalIndicationProps): boolean => {
  if (!cmgEntityKey) {
    return false;
  }

  const managerEntitlements = findEntitlements({
    cmgEntityKey: cmgEntityKey,
    syndicatesEntitlements,
  });

  return managerEntitlements.includes('UPDATE:INSTITUTIONAL_INDICATION');
};
